"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.filter.js");
require("core-js/modules/es.iterator.constructor.js");
require("core-js/modules/es.iterator.filter.js");
require("core-js/modules/es.json.parse.js");
require("core-js/modules/es.json.stringify.js");
require("core-js/modules/es.number.constructor.js");
require("core-js/modules/es.object.keys.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.regexp.to-string.js");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default2 = exports.default = {
  name: 'DialogRowDetail',
  props: {
    /* 弹窗控制 */
    open: {
      type: Boolean,
      default: false
    },
    /* dialog 标题 */
    title: {
      type: String,
      default: ''
    },
    /* 弹框打开类型 */
    openType: {
      type: String,
      default: 'view'
    },
    /* 行表单输入控件 */
    rowItem: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    /* 行表单数据对象 */
    rowDetailsForm: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    /* 行引索 */
    rowNo: {
      type: Number,
      default: 0
    },
    /* 行栅格控制器 */
    rowGrid: {
      type: Object,
      default: function _default() {
        return {
          span: 12,
          md: {
            span: 12
          },
          xs: {
            span: 24
          }
        };
      }
    },
    /* 行对话框宽度 */
    rowDialogWith: {
      type: String,
      default: '860px'
    },
    /* 行表单校验规则 */
    rowRules: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    /* label字段的宽度 */
    rowLabelWidth: {
      type: String,
      default: '100px'
    }
  },
  data: function data() {
    return {
      // findById, // 请求接口，组件会调用这个请求方法，在对话框打开的时候默认使用该方法请求表单数据并更新打开的对话框中的表单数据。如果去掉，则不会执行默认请求数据方法。
      show: false,
      // 对话框表单组件的显示状态
      loading: false,
      // 对话框表单的加载状态
      disabled: false,
      // 对话框表单的禁用状态（输入控件禁用）
      id: '',
      /** 对话框表单操作按钮 */
      btns: [// 对话框的标准区操作按钮（code 值参考规范文档）
      ],
      /** 栅格控制器（全局控制） */
      grid: this.rowGrid,
      /* 使用模版组件的字段 类目 */
      // formItems: {
      //   /** 输入控件模板 */
      //   basic: [
      //   ]
      // },
      /** 表单数据对象 */
      form: {},
      /** 表单校验规则 */
      rules: this.rowRules
    };
  },
  watch: {
    open: {
      handler: function handler(nv) {
        this.show = nv;
      }
    },
    show: {
      handler: function handler(nv) {
        this.$emit('update:open', nv);
      }
    },
    // rowItem: {
    //   handler(nv) {
    //     for (let i = 0; i < nv.length; i++) {
    //       this.formItems.basic[i] = nv[i]
    //     }
    //   }
    // },
    rowDetailsForm: {
      handler: function handler(nv) {
        if (!nv) return;
        this.form = JSON.parse(JSON.stringify(nv));
      }
    }
  },
  mounted: function mounted() {},
  methods: {
    getRowDict: function getRowDict(dictType, cellValue) {
      if (cellValue) {
        var list = this.$$getDict(dictType).filter(function (item) {
          return item.dictValue === cellValue.toString();
        });
        return list.length > 0 ? list[0].dictLabel : cellValue;
      }
      return '';
    },
    selectionRowChange: function selectionRowChange(code, value) {
      this.form[code] = value;
    },
    /* ok dialog dialog对话框右下角确定按钮触发事件 */onOk: function onOk() {
      this.show = false;
      this.$emit('updateRowDetail', JSON.parse(JSON.stringify(this.form)), this.rowNo);
    },
    /* open dialog 详情页对话框打开前触发 */openDialog: function openDialog() {},
    /* close dialog 详情页对话框关闭后触发 */closeDialog: function closeDialog() {},
    /* get datas success 对话框请求详细数据 成功 回调函数 */getDatasSuccess: function getDatasSuccess(res) {},
    /* get datas error 对话框请求详细数据 失败 回调函数 */getDatasError: function getDatasError(res) {}
  },
  created: function created() {
    this.show = this.open;
  }
};